export enum NotificationType {
    General = 0,
    DraftWalkIn = 1,
    FileShared = 2,
    CancelClinicDay = 3,
    ClinicDeleted = 4,
    AppointmentCanceled = 5,
    AppointmentCreated = 6,
    ClinicCreated = 7,
    DraftEpisodeCreated = 8,
    DraftNoteCrated = 9,
    LocalPrescription = 10,
    LocalEpisode = 11,
    LocalNote = 12,
    LocalPatient = 13,
    ClinicAssigned = 14,
    ClinicUnassigned = 15,
    AppointmentClinicianChanged = 16,
    SelfGrantedOrganizationAccess,
    GeneralWithRedirect,
    NhsAccessStatusAlertUserId,
    RequestedDocumentUploaded,
    PatientDocumentsUploaded
}

export const MarkAsReadRedirectNotifications = <NotificationType[]>[
    NotificationType.DraftWalkIn,
    NotificationType.LocalPrescription,
    NotificationType.LocalNote,
    NotificationType.LocalEpisode,
    NotificationType.LocalPatient,
    NotificationType.AppointmentCreated,
    NotificationType.AppointmentCanceled,
    NotificationType.CancelClinicDay,
    NotificationType.ClinicCreated,
    NotificationType.DraftNoteCrated,
    NotificationType.DraftEpisodeCreated,
    NotificationType.SelfGrantedOrganizationAccess,
    NotificationType.GeneralWithRedirect,
    NotificationType.RequestedDocumentUploaded,
    NotificationType.PatientDocumentsUploaded
];

export const MarkAsReadRedirectOpenDialogNotifications = <NotificationType[]>[
    NotificationType.AppointmentCreated,
    NotificationType.AppointmentCanceled,
    NotificationType.CancelClinicDay,
    NotificationType.ClinicCreated,
    NotificationType.SelfGrantedOrganizationAccess,
    NotificationType.NhsAccessStatusAlertUserId
];
